module.exports = __webpack_public_path__ + "18348161dd04c07f15aa9109e1551796.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_gauge.png
// module id = 835
// module chunks = 7